document.addEventListener("DOMContentLoaded", function () {

  /* Scroll reveal animation */
  const revealItems = document.querySelectorAll(".pme-reveal");

  if ("IntersectionObserver" in window) {
    const revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("pme-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12
      }
    );

    revealItems.forEach(function (item) {
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add("pme-visible");
    });
  }


  /* Animated numbers */
  const counters = document.querySelectorAll("[data-count]");

  if ("IntersectionObserver" in window) {
    const counterObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {

          if (!entry.isIntersecting) return;

          const counter = entry.target;
          const target = parseInt(counter.getAttribute("data-count"), 10);

          if (target === 0) {
            counter.textContent = "0";
            observer.unobserve(counter);
            return;
          }

          let current = 0;
          const duration = 900;
          const interval = 30;
          const steps = duration / interval;
          const increment = target / steps;

          const timer = setInterval(function () {
            current += increment;

            if (current >= target) {
              counter.textContent = target;
              clearInterval(timer);
            } else {
              counter.textContent = Math.floor(current);
            }
          }, interval);

          observer.unobserve(counter);
        });
      },
      {
        threshold: 0.5
      }
    );

    counters.forEach(function (counter) {
      counterObserver.observe(counter);
    });
  } else {
    counters.forEach(function (counter) {
      counter.textContent = counter.getAttribute("data-count");
    });
  }

});